(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
		if (!customElements.get('product-modal')) {
			class ProductModal extends ModalDialog {
				constructor() {
					super();
				}

				hide() {
					super.hide();
					window.pauseAllMedia();
				}

				show(opener) {
					super.show(opener);
					this.showActiveMedia();
					const lazyImages = this.querySelectorAll('.lazy-image');
					if(lazyImages.length > 0) {
						lazyImages.forEach(img => {
							this.loadImage(img)
							img.classList.remove('lazy-image');
						});
					}
				}

				loadImage = (img) => {
					img.src = img.dataset.src;
					img.srcset = img.dataset.srcset;
					img.sizes = img.dataset.sizes;
					img.classList.remove('lazy-image');
				}

				showActiveMedia() {
					this.querySelectorAll(
						`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
					).forEach((element) => {
						element.classList.remove('active');
					});
					const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
					const activeMediaTemplate = activeMedia.querySelector('template');
					const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
					activeMedia.classList.add('active');
					activeMedia.scrollIntoView();

					const container = this.querySelector('[role="document"]');
					container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

					if (
						activeMedia.nodeName == 'DEFERRED-MEDIA' &&
						activeMediaContent &&
						activeMediaContent.querySelector('.js-youtube')
					)
						activeMedia.loadContent();
				}
			}

			customElements.define('product-modal', ProductModal);
		}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	if (!customElements.get('cart-note')) {
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener('change', debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
				}, 300))
			}
		}

		customElements.define('cart-note', CartNote);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	if (!customElements.get('cart-note')) {
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					'change',
					debounce((event) => {
						const body = JSON.stringify({ note: event.target.value });
						fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
					}, 300)
				);
			}
		}

		customElements.define('cart-note', CartNote);
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
		if (!customElements.get('product-modal')) {
			class ProductModal extends ModalDialog {
				constructor() {
					super();
				}

				hide() {
					super.hide();
					window.pauseAllMedia();
				}

				show(opener) {
					super.show(opener);
					this.showActiveMedia();
					const lazyImages = this.querySelectorAll('.lazy-image');
					if(lazyImages.length > 0) {
						lazyImages.forEach(img => {
							this.loadImage(img)
							img.classList.remove('lazy-image');
						});
					}
				}

				loadImage = (img) => {
					img.src = img.dataset.src;
					img.srcset = img.dataset.srcset;
					img.sizes = img.dataset.sizes;
					img.classList.remove('lazy-image');
				}

				showActiveMedia() {
					this.querySelectorAll(
						`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
					).forEach((element) => {
						element.classList.remove('active');
					});
					const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
					const activeMediaTemplate = activeMedia.querySelector('template');
					const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
					activeMedia.classList.add('active');
					activeMedia.scrollIntoView();

					const container = this.querySelector('[role="document"]');
					container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

					if (
						activeMedia.nodeName == 'DEFERRED-MEDIA' &&
						activeMediaContent &&
						activeMediaContent.querySelector('.js-youtube')
					)
						activeMedia.loadContent();
				}
			}

			customElements.define('product-modal', ProductModal);
		}
	
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waterfall-collection"] && !Shopify.designMode) return;
  try {
    
function popiWaterfallInit(){(()=>{const r=document.getElementById('popi-collection-set');if(!r)return;const a=JSON.parse(r.querySelector('#set-assets').textContent);const matrices={"journey": [1.1264684480808338, -0.01731363608961897, -0.06807310849738003, 0.030115149877234633, 1.1443756953349156, -0.301445592032866, -0.00022005421658160437, 0.016270348113476933], "dawning": [1.0503045568575253, -0.018183943158890683, -0.019792085632005064, 0.008404017652111372, 1.0301924971879932, -0.19602991261657923, 0.01136027161801757, -0.0281464226063929], "return": [1.0299918378652295, -0.013431602552806713, -0.034826252918410176, -0.007045859140919474, 1.0329229500587882, -0.15777953841866185, -0.014337427557537454, -0.017792058775866183]};function place(i){const W=i.parentElement.getBoundingClientRect().width;if(!W)return;const [a,b,c,d,e,f,g,h]=matrices[i.dataset.frameArt];i.style.transform='matrix3d('+[a,d,0,g/W,b,e,0,h/W,0,0,1,0,c*W,f*W,0,1].join(',')+')';}r.querySelectorAll('[data-frame-art]').forEach(i=>{i.onload=()=>place(i);i.src=a[i.dataset.frameArt];new ResizeObserver(()=>place(i)).observe(i.parentElement);place(i);});const b=r.querySelector('button');if(b)b.onclick=()=>{const d=r.querySelector('#set-included');d.hidden=!d.hidden;b.setAttribute('aria-expanded',String(!d.hidden));};})();

(()=>{const root=document.getElementById('waterfall-world');if(!root||root.dataset.initialised)return;root.dataset.initialised='true';const assets=JSON.parse(root.querySelector('#wf-assets').textContent);const names={dawning:root.querySelector('#wf-dawn h2')?.innerText.replace(/\s+/g,' ')||'',journey:root.querySelector('#wf-journey h2')?.innerText.replace(/\s+/g,' ')||'',return:root.querySelector('#wf-return h2')?.innerText.replace(/\s+/g,' ')||''};const ambient=root.querySelector('.ambient');for(let i=0;i<40;i++){const line=document.createElement('span');line.className='waterline';line.style.cssText=`--x:${i%2?2+(i*13)%16:82+(i*7)%16}%;--y:${(i*293)%3400}px;--speed:${5+i%5}s;--delay:-${i%9}s`;ambient.append(line);}for(let i=0;i<4;i++){const r=document.createElement('span');r.className='ripple';r.style.cssText=`--x:${15+i*20}%;--delay:-${i*2}s`;ambient.append(r);}const motion=root.querySelector('.motion');const mq=matchMedia('(prefers-reduced-motion: reduce)');function paused(v){root.classList.toggle('paused',v);motion.textContent=v?window.popiWaterfallStrings.js_96:window.popiWaterfallStrings.js_97;motion.setAttribute('aria-pressed',String(v));}paused(mq.matches||root.dataset.motion==='false');motion.onclick=()=>paused(!root.classList.contains('paused'));const dialog=root.querySelector('dialog');
const galleries=JSON.parse(root.querySelector('#wf-galleries').textContent), strings=window.popiWaterfallStrings;
const viewport=dialog.querySelector('.gallery-viewport'), photo=viewport.querySelector('img'), zoom=dialog.querySelector('.gallery-zoom');
let active='journey', index=0, trigger=null, priorOverflow='';
function fit(){viewport.classList.remove('is-zoomed');zoom.textContent=strings.gallery_zoom;zoom.setAttribute('aria-pressed','false');viewport.scrollTop=0;viewport.scrollLeft=0;}
function render(){fit();const list=galleries[active],item=list[index];photo.src=item.src;photo.alt=names[active]+' — '+(item.caption||strings[item.label]||'');dialog.querySelector('.dialog-title').textContent=photo.alt;dialog.querySelector('.gallery-count').textContent=(index+1)+' '+strings.gallery_of+' '+list.length;}
function move(step){index=(index+step+galleries[active].length)%galleries[active].length;render();}
root.querySelectorAll('[data-key]').forEach(b=>b.onclick=()=>{active=b.dataset.key;if(!galleries[active]?.length)return;index=Number(b.dataset.index||0);trigger=b;render();priorOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';dialog.showModal();});
zoom.onclick=()=>{const yes=viewport.classList.toggle('is-zoomed');zoom.setAttribute('aria-pressed',String(yes));zoom.textContent=yes?strings.gallery_fit:strings.gallery_zoom;};
dialog.querySelector('.gallery-prev').onclick=()=>move(-1);dialog.querySelector('.gallery-next').onclick=()=>move(1);
dialog.querySelector('.close').onclick=()=>dialog.close();
dialog.addEventListener('close',()=>{document.documentElement.style.overflow=priorOverflow;fit();if(trigger)trigger.focus({preventScroll:true});});
dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
dialog.addEventListener('keydown',e=>{if(!viewport.classList.contains('is-zoomed')&&(e.key==='ArrowLeft'||e.key==='ArrowRight')){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});
let touchX=0,touchY=0;viewport.addEventListener('touchstart',e=>{touchX=e.changedTouches[0].clientX;touchY=e.changedTouches[0].clientY;},{passive:true});viewport.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-touchX,dy=e.changedTouches[0].clientY-touchY;if(!viewport.classList.contains('is-zoomed')&&Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)*1.5)move(dx<0?1:-1);},{passive:true});
if('IntersectionObserver' in window){const obs=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.remove('waiting');obs.unobserve(e.target);}}),{threshold:.08});root.querySelectorAll('.rise').forEach(e=>{e.classList.add('waiting');obs.observe(e);});}})();
}
if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",popiWaterfallInit);}else{popiWaterfallInit();}document.addEventListener("shopify:section:load",popiWaterfallInit);
document.addEventListener('shopify:block:select',e=>{const selected=document.querySelector('[data-shopify-editor-block*="'+e.detail.blockId+'"]');if(selected?.matches('[data-key]'))selected.click();});

  } catch(e) { console.error(e); }
})();
})();
